
exports.init = function () {
    var $document = $(document);

    // Hide placeholder option when select is opened
    $document.on('focus', '.reasonselector-select.js-reason-select', function(e) {
        var $select = $(this);
        var $placeholder = $select.find('option[value=""][disabled]');
        $placeholder.hide();
    });

    // Show placeholder again if no selection made and select is closed
    $document.on('blur', '.reasonselector-select.js-reason-select', function(e) {
        var $select = $(this);
        var value = $select.val();
        if (!value) {
            var $placeholder = $select.find('option[value=""][disabled]');
            $placeholder.show();
        }
    });

    // Handle reason selection for native select
    $document.on('change', '.reasonselector-select.js-reason-select', function(e) {
        var $select = $(this);
        var $selector = $select.closest('.js-reasonselector');
        var $submitButton = $('#js-reason-button');
        var value = $select.val();

        // Enable/disable submit button based on selection
        if (value) {
            $submitButton.prop('disabled', false).removeClass('disabled');
        } else {
            $submitButton.prop('disabled', true).addClass('disabled');
        }
    });

};
